/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Okular_TypeInputs */

const en_pc_alt_t_okular_type = /** @type {(inputs: Pc_Alt_T_Okular_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KDE document viewer`)
};

const zh_pc_alt_t_okular_type = /** @type {(inputs: Pc_Alt_T_Okular_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KDE 文档查看器`)
};

/**
* | output |
* | --- |
* | "KDE document viewer" |
*
* @param {Pc_Alt_T_Okular_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_okular_type = /** @type {((inputs?: Pc_Alt_T_Okular_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Okular_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_okular_type(inputs)
	return zh_pc_alt_t_okular_type(inputs)
});
export { pc_alt_t_okular_type as "pc.alt.t.okular.type" }